import * as React from 'react';
import PropTypes from 'prop-types';
import { times } from 'lodash';
import { Card, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { None, VialSummaryCardStyles } from './PlugStyles';
import {
  BLOOD_PRESSURE_VIAL_ID,
  STATUS_SKIPPED, VIALMAPPING,
} from '../constants';
import scannedtick from '../Assets/scanned-tick.svg';
import skippedtick from '../Assets/skipped-tick.svg';

const VialSummaryCard = ({ vialData, iteration }) => {
  const requireVitals = [BLOOD_PRESSURE_VIAL_ID];
  const barcodeScanned = vialData.barcode?.length > 0
    && vialData.reason_for_skip === STATUS_SKIPPED;
  const barcodeSkipped = vialData.barcode?.length < 1
    && vialData.reason_for_skip !== STATUS_SKIPPED;
  const isVitalsRequired = requireVitals.includes(vialData.vial_type);
  function generateAddedId() {
    return (
      <Box>
        {vialData?.barcode
          ? (
            <Typography
              sx={VialSummaryCardStyles.VialText}
            >
              VIAL {iteration + 1} | <b>ID: {vialData?.barcode}</b>
            </Typography>
          )
          : (
            <Typography
              sx={VialSummaryCardStyles.VialText}
            >
              VIAL {iteration + 1}
            </Typography>
          )}
      </Box>
    );
  }

  function generateScanStatus() {
    if (barcodeScanned) {
      return (
        <Box sx={VialSummaryCardStyles.ScannedBox}>
          <img src={scannedtick} alt="" height={16} width={16} id="tick-icon-scanned" />
          <Typography sx={VialSummaryCardStyles.Scanned}>Scanned</Typography>
        </Box>
      );
    }
    if (barcodeSkipped) {
      return (
        <Box sx={VialSummaryCardStyles.SkippedBox}>
          <img src={skippedtick} alt="" height={16} width={16} id="tick-icon-skipped" />
          <Typography sx={VialSummaryCardStyles.Skipped}>Skipped</Typography>
        </Box>
      );
    }
    if (!barcodeScanned && !barcodeSkipped && vialData && isVitalsRequired) {
      return (
        <Box sx={VialSummaryCardStyles.ScannedBox}>
          <img src={scannedtick} alt="" height={16} width={16} id="tick-icon-scanned" />
          <Typography sx={VialSummaryCardStyles.Scanned}>Recorded</Typography>
        </Box>
      );
    }
  }
  return (
    <Card elevation={0} sx={VialSummaryCardStyles.Card}>
      {generateAddedId()}
      <Card
        elevation={0}
        sx={VialSummaryCardStyles.ScanBox}
      >
        <img src={VIALMAPPING[vialData.vial_type] || VIALMAPPING[9999]} alt="profile" width={32} height={32} />
        <Typography sx={VialSummaryCardStyles.VialName}>{vialData?.vial_name}</Typography>
        {generateScanStatus()}
      </Card>
      <Box sx={barcodeSkipped ? VialSummaryCardStyles.UavBadge : None}>
        <Box sx={VialSummaryCardStyles.UavDes} />
        <Typography sx={VialSummaryCardStyles.UavText}>Vial recorded as unavailable.</Typography>
      </Box>
      <Card
        sx={VialSummaryCardStyles.List}
        elevation={0}
      >
        {
        times(vialData?.tests?.length, (i) => (
          <Box sx={{ display: 'flex' }} key={vialData.tests[i].name}>
            <Typography sx={VialSummaryCardStyles.ListDot}>•</Typography>
            <Typography sx={VialSummaryCardStyles.ListText}>{vialData.tests[i].name}</Typography>
          </Box>
        ))
        }
      </Card>
    </Card>
  );
};

VialSummaryCard.propTypes = {
  vialData: PropTypes.any,
  iteration: PropTypes.number,
};

export default VialSummaryCard;
